<template>
  <frameset name="Demo" nameColor="#006876" :topColor="['#005d6b', '#29bbc4']" v-if="isLogin">
    <span class="brandTxt-u fontM" slot="name">
        <span style="font-weight: 700;">{{$t('qssprojectName')}}</span>
        <span :style="headerObj">{{sysInfo.Product}}</span>
    </span>
    <ul class="dropdown-list" slot="dropdown-list">
      <span class="display-time">{{displayTime}}</span>
      <li class="dropdown dropdown-item user" :title="currentUser && currentUser.username" :class="{open: showUserMenu}">
        <a ref="user" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="true" @click="opensUserMenu">
          <div class="dropdown-icons-avatar icon-user"></div>
          <div class="username fontR">{{currentUser && currentUser.username}}</div>
          <div class="dropdown-icons-triangle">
            <div class="icon-triangle-down"></div>
          </div>
        </a>
        <ul ref="userMenu" class="dropdown-menu menu" role="menu">
          <li @click="onLogoutClick" :title="$t('header.logout')"><a>{{$t('header.logout')}}</a></li>
        </ul>
      </li>
      <li class="dropdown dropdown-item more" :class="{open: showMore}">
        <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="true">
          <div @click="openMore" class="q-icon-button dropdown-icons-more icon-more" :class="{active: showMore}" :title="$t('header.more')"></div>
        </a>
        <ul ref="moreMenu" class="dropdown-menu menu" role="menu">
          <li @click="onOpenRestartClick" :title="$t('header.reboot')"><a>{{$t('header.reboot')}}</a></li>
          <li class="dropdown lang" :class="{open: showLangMenu}" @click="onOpenLangClick">
            <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="true" style="position:relative;">
              <div :class="{active: showLangMenu}" :title="$t('header.language')">{{$t('header.language')}}
                <span class="icon-arrow_right language"></span>
              </div>
            </a>
            <ul ref="langMenu" class="dropdown-menu lang" role="menu">
              <scrollbar ref="scrollbar" class="scrollbar-body">
                <li class="dropdown" v-for="(item, index) in langList" :key="item[0]" @click="changeLocale(item)">
                  <div :class="{'icon-tick': isLangTick(item[3], index)}" class="language"></div>{{item[1]}}</li>
              </scrollbar>
            </ul>
          </li>
          <li @click="onOpenAboutClick" :title="$t('about.title')"><a>{{$t('about.title')}}</a></li>
        </ul>
      </li>
    </ul>
  </frameset>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import Frameset from './Frameset'
import about from './About'
import config from '../config'
import moment from 'moment'
export default {
  name: 'station-header',
  components: {
    Frameset,
    about
  },
  data () {
    return {
      langList: config.languages,
      showMore: false,
      // showHelpSubmenu: false,
      showUserMenu: false,
      showRestart: false,
      showLangMenu: false,
      headerObj: {
        fontSize: '16px',
        borderLeft: '1px solid #fff',
        paddingLeft: '10px'
      },
      dateformat: 'YYYY/MM/DD',
      timeformat: 'HH:mm:ss',
      displayTime: '---- / -- / -- --:--:--',
      curTimeUnixTime: null,
      curtimeIntervalId: null,
      getLang: null
    }
  },
  created () {
    let me = this
    this.langList.unshift(['AUTO', this.$t('header.autodetect'), 'AUTO', 'AUTO'])
    this.getWebConfig().then(res => {
      me.getLang = res.result['Language']
    })
  },
  beforeMount: function () {
    let me = this
    document.addEventListener('click', function (e) {
      let temp = false
      let path = e.path || (e.composedPath && e.composedPath())
      for (const key in path) {
        if (path.hasOwnProperty(key)) {
          const element = path[key]
          if (!!element.nodeName && element.nodeName !== '#document') {
            if (element.classList.length > 0) {
              if (element.className && typeof (element.className) !== 'object' && element.className.indexOf('more') > -1) {
                temp = true
              } else if (element.className && typeof (element.className) !== 'object' && element.className.indexOf('user') > -1) {
                temp = true
              }
            }
          }
        }
      }
      if (!temp && me.showMore) {
        me.closeMore()
      } else if (!temp && me.showUserMenu) {
        me.closeUserMenu()
      }
    })
    this.getNtpAdminState()
    this.getSystemTime()
    this.getTimezone()
  },
  mounted () {
    this.getCurrentTime()
  },
  beforeDestroy () {
    clearInterval(this.curtimeIntervalId)
    this.curtimeIntervalId = null
  },
  watch: {
    curTimeUnixTime: function (value) {
      if (value) {
        let time = moment.unix(value).utc()
        if (this.timeConfig.isNTP) {
          time.utcOffset(this.timeConfig.timezone)
        }
        this.displayTime = time.format(this.dateformat + ' ' + this.timeformat)
      } else {
        this.displayTime = '---- / -- / -- --:--:--'
      }
    },
    currentUser: {
      handler (value) {
        if (!value) {
          clearInterval(this.curtimeIntervalId)
          this.curtimeIntervalId = null
        } else {
          this.getCurrentTime()
        }
      },
      immediate: true,
      deep: true
    },
    timeConfig: {
      handler (value) {
        this.getCurrentTime()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    openMore: function () {
      this.closeUserMenu()
      this.showMore = !this.showMore
      this.showLangMenu = false
    },
    closeMore: function (event) {
      this.showLangMenu = false
      this.showMore = false
    },
    opensUserMenu: function () {
      this.closeMore()
      this.showUserMenu = !this.showUserMenu
    },
    closeUserMenu: function () {
      this.showUserMenu = false
    },
    onOpenLangClick: function () {
      this.showLangMenu = !this.showLangMenu
      setTimeout(() => {
        this.$refs.scrollbar.calculate()
      }, 50)
    },
    onOpenAboutClick: function () {
      this.closeMore()
      this.openModal('about-modal')
      this.$modal.show('about-modal')
    },
    onLogoutClick: async function () {
      this.closeMore()
      this.closeUserMenu()
      this.$store.commit('setLoadingType', 'logout')
      this.$store.commit('updateFullLoadingStatus', true)
      await this.postLogout()
    },
    onOpenRestartClick: function (event) {
      this.closeMore()
      this.openModal('switch-reboot-modal')
      this.$modal.show('switch-reboot-modal')
    },
    changeLocale: async function (lang) {
      let trans = null
      if (lang[0] === 'AUTO') {
        let temp = window.navigator.userLanguage || window.navigator.language
        this.$store.commit('updateAutoDetect', true)
        if (temp) {
          temp = temp.replace('-', '_')
          if (temp.split('_')[0] === 'zh') {
            temp = temp.split('_')[1]
          } else {
            temp = temp.split('_')[0]
          }
          config.languages.forEach(function (e, i, a) {
            if (temp === e[0]) {
              trans = e[3]
            }
          })
        }
      } else {
        this.$store.commit('updateAutoDetect', false)
        trans = lang[3]
      }
      await this.loadLocale({
        lang: trans
      })
      this.$log.info('loadLocale finish')
      this.langList[0][1] = this.$t('header.autodetect')
      this.closeMore()
      if (this.isAutoDetect) trans = 'AUTO'
      this.getLang = trans
      setTimeout(() => {
        this.setWebConfig(trans)
      }, 1000)
    },
    getCurrentTime: function () {
      let currentTime = null
      let time = [this.timeConfig.time.YYYY, (this.timeConfig.time.MM - 1), this.timeConfig.time.DD, this.timeConfig.time.HR, this.timeConfig.time.MI, this.timeConfig.time.SE]
      this.timeConfig.isNTP ? currentTime = moment(time).utcOffset(this.timeConfig.timezone, true) : currentTime = moment(time).utcOffset(0, true)
      if (currentTime) {
        this.curTimeUnixTime = Number(currentTime.format('X'))
      }
      this.setTimeInterval()
    },
    setTimeInterval: function () {
      if (this.curtimeIntervalId === null && this.curTimeUnixTime) {
        this.curtimeIntervalId = setInterval(() => {
          this.curTimeUnixTime += 1
        }, 1000)
      }
    },
    isLangTick (item, index) {
      if (item === this.getLang) return true
      return false
    },
    ...mapMutations(['openModal', 'closeModal', 'openHelper', 'updateAutoDetect']),
    ...mapActions(['postLogout', 'loadLocale', 'getNtpAdminState', 'getSystemTime', 'getTimezone', 'setWebConfig', 'getWebConfig'])
  },
  computed: {
    ...mapState({
      currentUser: state => state.module.currentUser,
      isLogin: state => state.module.isLogin,
      isAdmin: state => state.module.isAdmin,
      lang: state => state.app.lang,
      isAutoDetect: state => state.app.isAutoDetect,
      sysInfo: state => state.module.systemHostInfo,
      currentTime: state => state.module.currentTime,
      timeConfig: state => state.module.timeConfig
    })
  }
}
</script>
<style lang="scss" scope>
@import '../assets/scss/variables.scss';
@import '../assets/scss/menu.scss';
.frameset {
  > .frameset-body {
    > .logo-container {
      > .brandTxt-u {
        margin-left: 15px;
        font-size: 24px;
        color: #fff;
        text-align: left;
        line-height: 24px;
      }
      > .divide {
        margin: 0px 20px;
        width: 2px;
        height: 16px;
        background: #3645AC;
        border-radius: 2px;
      }
      > .brandTxt-s {
        font-size: 18px;
        color: #2E3C97;
      }
      > .host {
        margin-left: 9px;
        width: 38px;
        height: 20px;
        background-image: url('../assets/common/host.svg')
      }

    }
  }
}
.display-time {
  font-size: 16px;
  padding: 4px 20px 0px 0px;
  border-right: 1px solid #fff;
}
.dropdown-item {
  margin-left: 15px;
  border-radius: 20px;
  border: 1px solid transparent;
  &.user {
    a {
      cursor: default;
      &:hover {
        text-decoration: none;
      }
    }
    margin-left: 15px;
    .dropdown-icons-avatar {
      color: #fff;
      vertical-align: middle;
      display: inline-block;
      height: 20px;
      width: 20px;
      margin: auto;
    }
    .username {
      display: inline-block;
      margin-left: 10px;
      font-size: 16px;
      color: #fff;
      letter-spacing: 0;
      text-align: left;
      font-weight: 500;
      line-height: 36px;
      vertical-align: middle;
    }
    .dropdown-icons-triangle {
      cursor: pointer;
      color: #fff;
      vertical-align: middle;
      display: inline-block;
      font-size: 20px;
      margin: auto;
    }
  } // .user
  &.more {
    width: 36px;
    height: 36px;
    cursor: pointer;
    .dropdown-icons-more {
      margin: 8px;
      width: 20px;
      height: 20px;
      position: relative;
      color: #fff;
    }
    &:hover {
      .dropdown-icons-more {
        color: #000;
      }
      background-color: #FCFDD2;
      border-radius: 20px;
    }
    > a {
      text-decoration: none;
    }
  } // .more
  >ul.dropdown-menu {
    right: 0;
    left: auto;
    z-index: $dropdown-z-index;
    &.menu {
      @extend .q-menu;
    }
  }
  .dropdown-menu.lang {
    @extend .q-menu;
    position: fixed;
    float: right;
    top: 95px;
    left: calc(100% - 390px);
    min-width: 190px;
    max-height: 390px;
    a {
      text-decoration: none;
      color: inherit;
      &:hover {
        color: inherit;
      }
    }
    >.scrollbar-body {
      max-height: 380px;
    }
  }
  .icon-arrow_right.language {
      margin: 7px;
      right: 0px;
      position: absolute;
  }
  .language {
    width: 16px;
    display: inline-block;
    font-size: 16px;
    vertical-align: middle;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StationHeader.vue